export const CUTOFF_HOUR = 3;
export const IDLE_MS = 10 * 60 * 1000;
export const TICK_MS = 20 * 1000;
export const RELOAD_RESET_MS = 3 * 1000;
export const MAX_ATTEMPTS = 3;

export const LAST_PERIOD_KEY = "daily_refresher_last_period";
export const ATTEMPTS_KEY = "daily_refresher_attempts";

export const SINGLETON_SYMBOL = Symbol.for("skailer.daily-refresher");

export const ACTIVITY_EVENTS = [
  "mousemove",
  "scroll",
  "wheel",
  "keydown",
  "pointerdown",
  "touchstart",
  "touchmove",
  "input",
] as const satisfies readonly (keyof WindowEventMap)[];
